export default "__VITE_ASSET__CzlG1lZq__"